import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import getVideoGenre from '../services/getVideoGenre'

export default function useVideoGenre(genreId) {
  const { categorySlug } = useParams()

  const { isLoading, data: genre } = useQuery(
    ['video_genre', genreId],
    () => getVideoGenre(genreId),
    {
      enabled: !!genreId,
    }
  )

  const activeCategory =
    genre?.videoCategories?.find(c => c.slug === categorySlug) ||
    genre?.videoCategories?.[0]

  return {
    isLoading,
    genre,
    activeCategory,
  }
}
